/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chevron': {
    width: 14,
    height: 22,
    viewBox: '0 0 7 11',
    data: '<path pid="0" _fill="#F1582B" d="M4.648 5.498L.19 9.613a.574.574 0 0 0 0 .85l.39.361a.675.675 0 0 0 .462.176.675.675 0 0 0 .46-.176l5.308-4.9a.574.574 0 0 0 0-.853L1.508.176A.675.675 0 0 0 1.047 0a.675.675 0 0 0-.461.176l-.39.36a.57.57 0 0 0 0 .851l4.452 4.11z"/>'
  }
})
